import {Component, Inject, OnInit} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';
import {FlightScheduleEditorParameters} from './FlightScheduleEditorParameters';
import {FlightSchedule} from '../../interfaces/FlightSchedule';
import {ScheduleColumnValue} from '../../interfaces/ScheduleColumnValue';
import {ScheduleColumn} from '../../interfaces/ScheduleColumn';
import {FieldValue} from '../../../form-renderer/interfaces/FieldValue';
import {FlightScheduleService} from '../../services/flight-schedule-service/flight-schedule.service';
import {FormGroup} from '@angular/forms';
import {FieldFormService} from '../../../fields/services/field-form/field-form.service';

@Component({
  selector: 'app-flight-schedule-editor',
  templateUrl: './flight-schedule-editor-dialog.component.html',
  styleUrls: ['./flight-schedule-editor-dialog.component.scss']
})
export class FlightScheduleEditorComponent implements OnInit {

  public flightSchedule: FlightSchedule;
  public formGroup = new FormGroup({});
  constructor(public dialogRef: MdDialogRef<FlightScheduleEditorComponent>,
              @Inject(MD_DIALOG_DATA) public data: FlightScheduleEditorParameters,
              private flightScheduleService: FlightScheduleService,
              private fieldControlService: FieldFormService) { }

  ngOnInit() {
    if (this.data.flightSchedule) {
      this.flightSchedule = this.data.flightSchedule;
      this.flightSchedule.schedule_column_values = this.mergeScheduleColumnsWithScheduleColumnValues(
        this.data.scheduleColumns,
        this.flightSchedule.schedule_column_values
      );
      if (this.flightSchedule.start_date)
        console.log(this.flightSchedule.start_date);
        this.flightSchedule.start_date_date =
            new Date(new Date(this.flightSchedule.start_date).valueOf() + (new Date().getTimezoneOffset() * 60000));
        console.log(this.flightSchedule.start_date_date);
      if (this.flightSchedule.end_date)
        this.flightSchedule.end_date_date =
            new Date(new Date(this.flightSchedule.end_date).valueOf() + (new Date().getTimezoneOffset() * 60000));
    } else {
      this.flightSchedule = {
        contract_id: this.data.contractId,
        recurrence_monday: false,
        recurrence_tuesday: false,
        recurrence_wednesday: false,
        recurrence_thursday: false,
        recurrence_friday: false,
        recurrence_saturday: false,
        recurrence_sunday: false,
        schedule_column_values: this.mergeScheduleColumnsWithScheduleColumnValues(this.data.scheduleColumns)
      }
    }
    console.log(this.flightSchedule);
    this.buildFormGroup();
  }

  public cancel() {
    this.dialogRef.close();
  }

  private buildFormGroup() {
    this.formGroup = this.fieldControlService.toFormGroup(this.flightSchedule.schedule_column_values.map((column) => column.field_value))
  }

  public save() {
    const creation = this.flightSchedule.id == null;
    if (this.flightSchedule.start_date_date)
      this.flightSchedule.start_date = this.flightSchedule.start_date_date.toDateString();
    if (this.flightSchedule.end_date_date)
      this.flightSchedule.end_date = this.flightSchedule.end_date_date.toDateString();
    this.flightScheduleService.upsert(this.flightSchedule).then((flightSchedule) => {
      console.log(flightSchedule);
      this.dialogRef.close({ creation: creation, flightSchedule: flightSchedule});
    });
  }

  /**
   * Merge the values on the object and the values or columns that are specified.
   * @param {ScheduleColumn[]} scheduleColumns
   * @param {ScheduleColumnValue[]} scheduleColumnValues
   * @returns {ScheduleColumnValue[]}
   */
  private mergeScheduleColumnsWithScheduleColumnValues(
    scheduleColumns: ScheduleColumn[], scheduleColumnValues: ScheduleColumnValue[] = [], ): ScheduleColumnValue[] {
    scheduleColumns.forEach((scheduleColumn) => {
      const foundValue  = scheduleColumnValues.find((value) => value.schedule_column_id === scheduleColumn.id);
      if (foundValue)
        return;
      scheduleColumnValues.push({
        schedule_column_id: scheduleColumn.id,
        field_value: this.getFieldValueFromScheduleColumn(scheduleColumn),
      });
    });
    return scheduleColumnValues;
  }

  private getFieldValueFromScheduleColumn(scheduleColumn: ScheduleColumn): FieldValue {
    return {
      field: scheduleColumn.field,
      field_id: scheduleColumn.field_id,
      check_value: null,
      comment: null,
      date_value: null,
      decimal_value: null,
      int_value: null,
      select_value: null,
      string_value: null,
      timestamp_value: null
    }
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/contract/components/flight-schedule-editor/flight-schedule-editor-dialog.component.ts